import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/atoms/rich-text-render/RichTextRender.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OnsenBannerSection"] */ "/app/src/components/organisms/partners/OnsenBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LazySearchAvailableRoomForm"] */ "/app/src/components/organisms/search-avaliable/LazySearchAvailableRoomForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PartnerSearchHotelMobile"] */ "/app/src/components/organisms/search-avaliable/PartnerSearchHotelMobile.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HotelBrands"] */ "/app/src/components/organisms/top-page/brands-section/HotelBrands.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/organisms/top-page/latest-news-section/LatestNewsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PickupSection"] */ "/app/src/components/organisms/top-page/pickup-section/PickupSection.tsx");
